module.exports = __webpack_public_path__ + "static/media/positive_vote.264cd25c.svg";